import React from 'react';

import { Link, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const NameFormatter = ({ row }) => {
    return (
        <Link
            href={`/company-file/${row.id}`}
            underline="hover"
            sx={{ textAlign: 'left', color: '#424242' }}
        >
            <Typography fontWeight="bold" variant="caption">
                {row?.business_name}
            </Typography>
        </Link>
    );
};

NameFormatter.propTypes = {
    row: PropTypes.object,
};

export default NameFormatter;
